import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { RootState } from '../store';
import Logo from './Logo';
import MainNavigation from './MainNavigation';
import Painting from './Painting';
import VirtualHelp from './VirtualHelp';
import VirtualInfo from './VirtualInfo';
import { initLayoutState1, LayoutMaxWidth, MediaQueryFixMargin, MediaQueryMobile, MediaQueryScaleMargin, MediaQueryShallow, MediaQuerySmall1, MediaQuerySmall2, MediaQuerySmall3, MediaQuerySmall4, MediaQuerySmall5 } from '../Layout';
import SiteVirtualTour from './SiteVirtualTour';
import SiteMobile from './SiteMobile';
import SiteDesktop from './SiteDesktop';

export default function Site() {
    const fixMargin = useMediaQuery(MediaQueryFixMargin);
    const scaleMargin = useMediaQuery(MediaQueryScaleMargin);
    const isMobile = useMediaQuery(MediaQueryMobile);
    const isSmall1 = useMediaQuery(MediaQuerySmall1);
    const isSmall2 = useMediaQuery(MediaQuerySmall2);
    const isSmall3 = useMediaQuery(MediaQuerySmall3);
    const isSmall4 = useMediaQuery(MediaQuerySmall4);
    const isSmall5 = useMediaQuery(MediaQuerySmall5);
    const layoutState = initLayoutState1(fixMargin, scaleMargin, isMobile, isSmall1, isSmall2, isSmall3, isSmall4, isSmall5);
    layoutState.isShallow = useMediaQuery(MediaQueryShallow);

    if (!isMobile) {
        return <SiteDesktop layoutState={layoutState}></SiteDesktop>
    }
    else {
        return <SiteMobile />;
    };
}